var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5291 98.3333H93.9392C99.5924 98.3333 104.089 95.7575 108.127 92.156C118.383 83.0061 94.2726 73.75 86.0416 73.75M76.2083 24.9215C77.3248 24.7 78.4842 24.5833 79.6735 24.5833C88.6214 24.5833 95.8749 31.1872 95.8749 39.3333C95.8749 47.4795 88.6214 54.0833 79.6735 54.0833C78.4842 54.0833 77.3248 53.9668 76.2083 53.7451",
    strokeWidth: 8.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0331 79.2134C16.2365 82.3198 1.0381 88.6627 10.2949 96.5997C14.8168 100.477 19.8531 103.25 26.1848 103.25H62.3153C68.647 103.25 73.6831 100.477 78.205 96.5997C87.4621 88.6627 72.2637 82.3198 66.4669 79.2134C52.8738 71.9289 35.6261 71.9289 22.0331 79.2134Z",
    strokeWidth: 8.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9166 36.875C63.9166 47.7366 55.1113 56.5417 44.2499 56.5417C33.3883 56.5417 24.5833 47.7366 24.5833 36.875C24.5833 26.0134 33.3883 17.2083 44.2499 17.2083C55.1113 17.2083 63.9166 26.0134 63.9166 36.875Z",
    strokeWidth: 8.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.111999affa7117fe005d06a33bcbd831.svg";
export { ForwardRef as ReactComponent };